import { Trash } from "phosphor-react";

interface ImagePreviewProps {
  image: string | null;
  onRemove: () => void;
  type: "screenshot" | "upload";
}

export function ImagePreview({ image, onRemove, type }: ImagePreviewProps) {
  if (!image) return null;

  return (
    <div className="absolute inset-0 z-10 bg-zinc-800 rounded-md overflow-hidden border border-zinc-600">
      <img
        src={image}
        alt={type === "screenshot" ? "Screenshot da página" : "Imagem enviada"}
        className="w-full h-full object-cover"
      />
      <button
        type="button"
        title="Remover imagem"
        aria-label="Remover imagem"
        onClick={onRemove}
        className="absolute top-2 right-2 p-1 bg-zinc-900/60 rounded-md text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800/60 transition-colors duration-200 ease-in-out"
      >
        <Trash weight="fill" className="w-4 h-4" />
      </button>
    </div>
  );
}
